"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AlpineProductComparisonSeries;
var swiper_1 = __importDefault(require("swiper"));
var modules_1 = require("swiper/modules");
function AlpineProductComparisonSeries() {
    return Alpine.data('productComparisonSeries', function () { return ({
        API_URL: '',
        initialized: false,
        loading: true,
        comparisonProductsIds: '',
        comparisonProducts: [],
        productAttributesTerm: '',
        productAttributeMeta: [],
        comparisonAttributes: [],
        rowHeights: [],
        swiper: null,
        scrolledIntoComparison: false,
        handleIntersect: function (enter) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    console.log("INTERSECTED ".concat(enter));
                    this.scrolledIntoComparison = enter;
                    return [2 /*return*/];
                });
            });
        },
        createProductComparison: function (productIds, attributeTerm) {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.time();
                            console.log('createProductComparison');
                            (_a = document.querySelectorAll('#product-comparison')[0]) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                            this.initialized = true;
                            this.loading = true;
                            this.comparisonProducts = [];
                            this.productAttributeMeta = [];
                            this.comparisonAttributes = [];
                            this.rowHeights = [];
                            this.comparisonProductsIds = productIds || '';
                            this.productAttributesTerm = attributeTerm || '';
                            this.API_URL = '/graphql';
                            return [4 /*yield*/, this.getProductAttributes()];
                        case 1:
                            _b.sent();
                            return [4 /*yield*/, this.getComparisonProducts()];
                        case 2:
                            _b.sent();
                            return [4 /*yield*/, this.createSwiper()];
                        case 3:
                            _b.sent();
                            this.loading = false;
                            this.$nextTick(function () { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.calculateCellHeights()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                            console.log('createProductComparison finished');
                            console.timeEnd();
                            return [2 /*return*/];
                    }
                });
            });
        },
        getComparisonProducts: function () {
            return __awaiter(this, void 0, void 0, function () {
                var productAttributesMetaResponse;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('getComparisonProducts');
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryStringForProducts)];
                        case 1:
                            productAttributesMetaResponse = (_a.sent());
                            return [2 /*return*/, new Promise(function (resolve) {
                                    _this.comparisonProducts = productAttributesMetaResponse;
                                    resolve();
                                })];
                    }
                });
            });
        },
        getProductAttributes: function () {
            return __awaiter(this, void 0, void 0, function () {
                var productAttributesResponse;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log('getProductAttributes');
                            return [4 /*yield*/, this.graphQLRequest(this.graphQLQueryProductAttributes)];
                        case 1:
                            productAttributesResponse = (_a.sent());
                            return [2 /*return*/, new Promise(function (resolve) {
                                    if (productAttributesResponse.length < 1) {
                                        console.error('No attributes found');
                                    }
                                    _this.comparisonAttributes = productAttributesResponse;
                                    var comparisonQueryAttributesAsString = '';
                                    _this.comparisonAttributes.forEach(function (attribute) {
                                        comparisonQueryAttributesAsString = "".concat(comparisonQueryAttributesAsString, ",").concat(attribute.productAttribute);
                                    });
                                    var comparisonAttributesAsArray = comparisonQueryAttributesAsString.trim().split(',');
                                    var trimmedAttributesArray = (comparisonAttributesAsArray.slice(1, comparisonAttributesAsArray.length));
                                    _this.productAttributeMeta = trimmedAttributesArray;
                                    resolve();
                                })];
                    }
                });
            });
        },
        createSwiper: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _this = this;
                return __generator(this, function (_a) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            var prevButton = _this.$root.querySelector('[data-swiper-navigation-prev]');
                            var nextButton = _this.$root.querySelector('[data-swiper-navigation-next]');
                            _this.swiper = new swiper_1.default(_this.$refs.productsSwiper, {
                                modules: [modules_1.Navigation, modules_1.A11y],
                                breakpoints: {
                                    0: {
                                        slidesPerGroup: 1,
                                        slidesPerView: 1.25,
                                        spaceBetween: 0,
                                    },
                                    768: {
                                        slidesPerGroup: 1,
                                        slidesPerView: 2.25,
                                        spaceBetween: 0,
                                    },
                                    1280: {
                                        slidesPerGroup: 1,
                                        slidesPerView: 3,
                                        spaceBetween: 0,
                                    },
                                },
                                navigation: {
                                    prevEl: prevButton,
                                    nextEl: nextButton,
                                },
                                on: {
                                    init: function () {
                                        resolve();
                                    },
                                },
                            });
                        })];
                });
            });
        },
        /* eslint-disable */
        graphQLRequest: function (queryString) {
            return __awaiter(this, void 0, void 0, function () {
                var response, data;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, fetch(this.API_URL, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    query: queryString
                                }),
                            })];
                        case 1:
                            response = _d.sent();
                            return [4 /*yield*/, response.json()];
                        case 2:
                            data = _d.sent();
                            if (data.errors > 0) {
                                return [2 /*return*/];
                            }
                            if (((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.length) > 0
                                || ((_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.contentNodes) === null || _c === void 0 ? void 0 : _c.nodes.length) > 0) {
                                return [2 /*return*/, data.data.contentNodes.nodes];
                            }
                            return [2 /*return*/];
                    }
                });
            });
        },
        /* eslint-enable */
        calculateCellHeights: function () {
            var _this = this;
            return new Promise(function (resolve) {
                // this.$root.attributeStyleMap.clear();
                var rows = _this.$root.querySelectorAll('[data-attribute-row]');
                if (rows) {
                    rows.forEach(function (row) {
                        var index = parseInt(row.dataset.attributeRowIndex, 10) + 1;
                        var height = Math.ceil(parseInt(row.offsetHeight, 10));
                        var prev = Math.ceil(parseInt(_this.$root.style.getPropertyValue("--row-".concat(index, "-height")), 10));
                        if (!prev) {
                            _this.$root.style.setProperty("--row-".concat(index, "-height"), "".concat(height + 2, "px"));
                            return;
                        }
                        var newValue = (height > prev) ? height : prev;
                        _this.$root.style.setProperty("--row-".concat(index, "-height"), "".concat(newValue, "px"));
                    });
                }
                resolve();
            });
        },
        calculateHeaderHeights: function () {
            console.log('calculateHeaderHeights');
            var columns = this.$root.querySelectorAll('[data-attribute-column-title]');
            columns.forEach(function (col) {
                console.log(col.offsetHeight);
            });
        },
        get productAttributeMetaAsString() {
            var string = this.productAttributeMeta.forEach(function (attribute) { return "\"".concat(attribute, "\""); });
            return string;
        },
        get graphQLQueryStringForProducts() {
            return "query GetProducts {\n        contentNodes(\n          where: {\n            in: [".concat(this.comparisonProductsIds, "]\n          }\n          first: 10\n        ) {\n          nodes {\n            ... on Product {\n              databaseId\n              title\n              uri\n              featuredImage {\n                node {\n                  sourceUrl\n                }\n              }\n              taxProductCategories {\n                nodes {\n                  id\n                  name\n                }\n              }\n              taxIndustries {\n                nodes {\n                  id\n                  name\n                }\n              }\n              metaData(keysIn: [").concat(this.productAttributeMeta.map(function (key) { return "\"".concat(key, "\""); }).join(','), "]) {\n                key\n                value\n              }\n            }\n          }\n        }\n      }");
        },
        get graphQLQueryProductAttributes() {
            return "query GetProductAttributes {\n        contentNodes(\n          where: {\n            contentTypes: PAGE_ATTRIBUTE,\n            metaQuery: {\n              metaArray: {\n                key: \"hide_from_product_comparison_table\",\n                value: \"0\",\n                compare: EQUAL_TO\n              }\n            },\n            taxQuery: {\n              taxArray: {\n                field: ID,\n                taxonomy: TAX_PRODUCT_CATEGORY,\n                operator: IN,\n                terms: \"".concat(this.productAttributesTerm, "\"\n              }\n            }\n          }\n          first: 1000\n        ) {\n          nodes {\n            ... on Page_attribute {\n              title\n              slug\n              productAttribute\n              productAttributeFields {\n                hideFromProductComparisonTable\n                hideFromProductSearchFilter\n                label\n                outputStyle\n                prefix\n                suffix\n                type\n                comparisonType\n                options\n              }\n            }\n          }\n        }\n      }");
        },
        get graphQLQueryProductAttributesMeta() {
            return "query GetProductAttributeMetaNames {\n          contentNodes(\n            where: {\n              contentTypes: PAGE_ATTRIBUTE,\n              metaQuery: {\n                metaArray: {\n                  key: \"hide_from_product_comparison_table\",\n                  value: \"0\",\n                  compare: EQUAL_TO\n                }\n              },\n              taxQuery: {\n                taxArray: {\n                  field: ID,\n                  taxonomy: TAX_PRODUCT_CATEGORY,\n                  operator: IN,\n                  terms: \"".concat(this.productAttributesTerm, "\"\n                }\n              }\n            }\n            first: 1000\n          ) {\n            nodes {\n              ... on Page_attribute {\n                title\n                slug\n                productAttributeFields {\n                  hideFromProductComparisonTable\n                  hideFromProductSearchFilter\n                  label\n                  outputStyle\n                  prefix\n                  suffix\n                  type\n                  comparisonType\n                  options\n                }\n              }\n            }\n          }\n        }\n      ");
        },
    }); });
}
